module.exports = __webpack_public_path__ + "img/bus_sidebar_img_8.f6d774a8.svg";